import loadMan from "./user/loadManager.vue"
import chooseSec from "./user/chooseSecretary.vue"
import choosePost from "./user/choosePost.vue"
import staff from "./user/staffLevel.vue"
import infothird from "./user/infothirdLevel.vue"
import zgdept from "./user/zgDept.vue"
import first from "./user/firstDept.vue"
import queryrole from "./user/queryRoles.vue"
import token from "@/common/utils/token"
import { mapGetters } from 'vuex';

export default {

    components: {
        loadMan,
        chooseSec,
        choosePost,
        staff,
        infothird,
        zgdept,
        first,
        queryrole
    },
    props: {
        params: Object
    },
    data() {
        let readMode = this.params && this.params.readMode;
        let noResetPwd = this.params && this.params.noResetPwd;
        let showSaveBtn = this.params && this.params.showSaveBtn;
        let listAble = this.params && this.params.listAble;
        return {
            readMode: readMode,
            noResetPwd: noResetPwd,
            showSaveBtn: showSaveBtn,
            showHandOver: (window.$Env && $Env.showHandOverBtn ? true : false),
            listAble: listAble,
            //当前选中的节点id
            checkedId: '',
            userIdentityId: '',
            //当前选中的节点的text
            nodeText: '',
            identityId: '',
            // 转换部门或追加部门树是否为第一次加载
            init: true,
            init1: true,
            // 是否为第一次添加打开或编辑部门对话框
            firstDeptOpen: true,
            firstUserOpen: true,
            firstImpDeptOpen: true,
            firstImpUserOpen: true,
            firstUserDialogOpen: true,
            edit: false,
            editUser: false,
            isLimit: false,
            deptTreeUrl: '',
            showMJBS: false,
            defaultParams1: null,
            menuItem1: [],
            expandFlag: 2,
            primaryDUrl: this.mwUrl('/api/org/getUserDepartmentFullPath'),
            userInfo1: [],
            userLevelOption:[],
            btns: [{
                label: '取消',
                func: this.cancelChoose,
                type: 'default'
            }, {
                label: '确定',
                func: this.addTransUserDept
            }],
            btns1: [{
                label: '取消',
                func: this.cancelChoose1,
                type: 'default'
            }, {
                label: '确定',
                func: this.expChooseDeptUser
            }, {
                label: '全展开',
                func: this.openAll
            }, {
                label: '全选',
                func: this.checkAll
            }, {
                label: '不选',
                func: this.unCheckAll
            }],
            deptBtns: [{
              label: '确定',
              func: this.pDeptSure
            },{
                label: '取消',
                func: this.cancelChoosePDept,
                type: 'default'
            }],

            userFooterButton: [
              { label: '确定', func: this.chooseAdminSure },
                { label: '取消', func: this.cancelChooseAdmin, type: 'default' }
            ],

            imageUrl: '',
            layout: [],
            deptManagers: [],
            types: {
                "1": {
                    "icon": "fa fa-folder"
                },
                "2": {
                    "icon": "fa fa-leaf"
                },
                "3": {
                    "icon": "fa fa-users"
                },
                'default': {
                    "icon": "fa fa-leaf"
                }
            },
            menuItem: [{ name: 'add', icon: 'fa fa-plus-square', label: '添加', func: this.addDepart },
                {
                    name: 'edit',
                    label: '编辑',
                    icon: 'fa fa-pencil fa-fw',
                    func: this.editDept
                },
                {
                    name: 'delete',
                    label: '删除',
                    icon: 'fa fa-trash-o',
                    func: this.deleteDepartment
                }
            ],
            education: [{
                label: '小学',
                value: '1'
            }, {
                label: '初中',
                value: '2'
            }, {
                label: '高中',
                value: '3'
            }, {
                label: '本科',
                value: '4'
            }, {
                label: '专科',
                value: '5'
            }, {
                label: '硕士',
                value: '6'
            }, {
                label: '博士',
                value: '7'
            }, {
                label: '博士后',
                value: '8'
            }],
            dept: {
                name: '',
                shortname: '',
                Englishname: '',
                id: '',
                flag: '1',
                adminName: '',
                adminId: '',
                sn: '',
                listAble: '1',
                parentId: '',
                parentName: '',
                code: ''
            },

            user: {
                loginId: '',
                name: '',
                sex: '1',
                initial: '',
                pinyin: '',
                Englishname: '',
                password: '',
                email: '',
                label: '',
                applicationIdentityId: '',
                staffId: '',
                departmentName: '',
                departmentId: '',
                sn: '',
                phone: '',
                mobile: '',
                position: '',
                secretary: '',
                secretaryId: '',
                jobs: '',
                isSecret: '1',
                timeOfJoinInWork: '',
                workyear_: '',
                edu: '',
                userLevel: '',
                birth: '',
                age_: '',
                idNumber: '',
                weiChatNum: '',
                listAble: '1',
                roleNames: '',
                roleid: '',
                departmentIdentityId: '',
                companyEmail: '',
                zgdept: '',
                zgdeptid: '',
                staffLevel: '',
                secondRank: '',
                thirdRank: '',
                mjbs: '',
                persontype: '1',
                firstLevelDept: '',
                firstLevelDeptId: '',
                secondLevelDept: '',
                secondLevelDeptId: '',
                thirdLevelDept: '',
                thirdLevelDeptId: '',
                primaryDepartmentName: '',
                primaryDepartmentId: '',
                bindIP: '',
                avatarAttachId: ''
            },

            rules: {
                loginId: [
                    { required: true, message: "请输入账号", trigger: 'blur' }
                ],
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                applicationIdentityId: [
                    { required: true, message: '请输入编码', trigger: 'blur' }
                ],
                initial: [
                    { required: true, message: '请输入该人员姓名首字母', trigger: 'blur' }
                ],
            },

            deptRule: {
                name: [{ required: true, message: "请输入名称", trigger: 'blur' }]
            },

            defaultParentId: '',

            //判断是转换部门还是追加部门，默认true为追加部门
            addUserDept: false,
            exportDept: false,
            firstTime: true,
            loading: false,
            activeName: 'basic',
            staffLevel: false,
            info3: false,
            primaryTree: true,
            secFirst: false,
            showBtn: false,
            showJBBtn: false,
            defaultParams: {
                formId: 'e12www44134',
                businessId: 'e12www44134',
                type: 'e12www44134',
                tempBusinessId: 'e12www44134',
                flag: 'avatar'
            },
            headers: {},
            avatarStyle: {
                width: '120px',
                height: '120px'
            },
            fileList: [],

            signUrl: '',
            signParams: {
                formId: 'wtrgng6623',
                businessId: 'wtrgng6623',
                type: 'wtrgng6623',
                tempBusinessId: 'wtrgng6623'
            },
            fileSignList: [],

            buttons: [],
            action: this.mwUrl('/api/business/uploadAttachment'),
            importAction: '/api/org/importDepartmentUserFromExcel',
            importDeptAction: '/api/org/importDepartmentFromExcel',
            deptImpBtn: [{
                label: "取消",
                func: this.impDeptCancel,
                type: "default"
            }],
            leadButton: [{
                label: "取消",
                func: this.impUserCancel,
                type: "default"
            }],
            handOverTodoButton: [
              { label: '确定', func: this.chooseHandOverTodoSure },
                { label: '取消', func: this.cancelHandOverTodo, type: 'default' }
            ],
            handOverFinishButton: [
              { label: '确定', func: this.chooseHandOverFinishSure },
              { label: '取消', func: this.cancelHandOverFinish, type: 'default' }
            ],
            hideBtn: false, //hg项目的业务需隐藏某些按钮
            bindForm: {
                bindIP: "",
                userId: "",
            },
            handOverTodoForm: {
                assigned: '',
                assignedId: '',
                recipient: '',
                recipientId: ''
            },
            handOverFinishForm: {
                assigned: '',
                assignedId: '',
                recipient: '',
                recipientId: '',
                startTime: '',
                endTime: '',
                moduleName: '',
                moduleId: ''
            },
            chooseUsersRData: [],
            userSelIsMul: false,
            userSelFooterButton: [
              { label: '确定', func: this.chooseUserSure },
                { label: '取消', func: this.cancelUserSel, type: 'default' }
            ],
            handeOverSelField: { id: '', name: '', type: '' }
        };
    },
    created() {
        var isSysAdmin = this.isSysAdmin();
        if (this.userInfo.developer || isSysAdmin || this.userInfo.unitAdmin) {
            this.showBtn = true;
        } else {
            this.menuItem = [];
        }
        if (this.params && this.params.projectName && this.params.projectName == "hg") {
            this.showMJBS = true;
            this.hideBtn = true;
        }
        if (this.params && this.params.showJBBtn) {
            this.showJBBtn = this.params.showJBBtn;
        }
        if (this.params && this.params.showBtn) {
            this.showBtn = this.params.showBtn;
        }

        this.buttons = (this.showBtn == true && !this.readMode && !this.hideBtn) ? [{
            label: '添加',
            icon: 'fa fa-plus-square',
            func: this.addUser
        }, {
            label: '删除',
            icon: 'fa fa-trash-o fa-fw',
            func: this.deleteUser
        }] : []
        this.buttons.push({
            label: '查看角色',
            icon: 'fa ',
            func: this.roleLookUp
        })
    },

    mounted() {

        let me = this;
        //  me.headers.Authorization = PF.token.getToken();
        me.layout = [
            [{
                    span: 0,
                    type: 'menu',
                    label: '组织人员',
                    api: 'org.listDepartmentUserPaging',
                    defaultParams: { noIdentityInfo: "false", notShowRoleName: true },
                    defaultSort: [{ sort: 'sn', dir: 'desc' }],
                    nowrap: false,
                    columns: [
                        { type: 'selection', reserve: true },
                        { label: '序号', prop: 'sn', width: '55' },
                        //{prop: 'isAdmin',label: '',formatter: me.adminFormatter,width: '40'},
                        { slot: { type: "href", func: me.dbHandleRow }, prop: 'name', width: '100', label: '姓名', tooltip: true },
                        { prop: 'loginId', label: '帐号', tooltip: true, width: '100' },
                        { prop: 'phone', label: '座机电话', width: '113', tooltip: true },
                        { prop: 'mobile', label: '移动电话', width: '113', tooltip: true },
                        { prop: 'email', label: '电子邮箱', tooltip: true, width: '150' },
                        { prop: 'departmentFullName', label: '组织', tooltip: true, formatter: me.departmentFullNameFormatter },
                        //{prop: 'roleNames', label: '权限',tooltip:true,width:'300'}
                        //{prop: 'lastModifiedTime', label: '最后修改',tooltip:true}
                    ]
                }, {
                    span: 18,
                    type: 'button',
                    items: this.buttons,
                    suffixSlot: "dropDown"
                },
                {
                    span: 5,
                    type: 'searchText',
                    offset: 0,
                    name: 'qcon',
                    tip: "姓名,帐号等"
                }, {
                    span: 1,
                    type: 'custom',
                    items: []
                }
            ]
        ];
        var isSysAdmin = this.isSysAdmin();
        if ((this.userInfo.developer || isSysAdmin) && !this.listAble) {
            let api = '/api/org/listDepartmentAndCount?t=' + Date.now();
            this.deptTreeUrl = this.mwUrl(api);
        } else {
            if (this.userInfo.unitAdmin || this.userInfo.departmentAdmin || this.listAble) {
                let rootId;
                if (this.expUser.dep.loginUnit) {
                    rootId = this.expUser.dep.loginUnit.id;
                } else {
                    rootId = this.expUser.dep.loginRootDept.id;
                }
                this.defaultParams1 = { rootId: rootId, t: Date.now() };
                if (this.listAble) this.defaultParams1.listAble = true;
                let api = '/api/org/getDepartmentTreeCount';
                // if (this.listAble) api += '&listAble=true';
                this.deptTreeUrl = this.mwUrl(api);
                if (this.showBtn == true) {
                    this.menuItem1 = this.menuItem;
                } else if (this.userInfo.departmentAdmin) {

                }
            }
        }
        me.$nextTick(function() {
          if(!me.hideBtn){
            $(me.$el).find("[toolbar_custom_area='true']").append(`<button id="showhelp" style="float:right;padding-left: 0;padding-right: 0;width: 30px;text-align: center;" type="button" class="el-button el-button--info"><span class="text-center"><i class="fa fa-question" style="padding-right: 0;margin-right: 0;"></i><span>${$lang('')}</span></span></button>`);
            $("#showhelp").click(function() {
              me.showHelp();
            })
          }
          me.processSelRowData();
          me.showTreeRightPanel(); //根目录添加处理
          if (this.params && this.params.isSaveQueryUserLog == true)
              me.queryUserLog();
        })
    },

    computed: {
        ...mapGetters([
            'userInfo',
            'expUser'
        ]),
        birth: function() {
            return this.user.birth;
        },
        timeOfJoinInWork: function() {
            return this.user.timeOfJoinInWork
        }
    },
    watch: {
        birth: function(newValue, oldValue) {
            this.user.age_ = this.ageNum(newValue);
        },
        timeOfJoinInWork: function(newValue, oldValue) {
            this.user.workyear_ = this.ageNum(newValue);
        }
    },
    methods: {
        showUserUpload() {
            if (this.firstImpUserOpen) {
                this.initUploader("user");
                this.firstImpUserOpen = false;
            }
        },
        tableRowStyle(row, index, ret) {
            if (row.row.listAble == "2") {
                ret["background-color"] = "#ddd" //{'background-color':'red',color:'red'}
            }
        },
        treeDataFilter(data) {
            let me = this;
            if (data) {
                _.each(data, function(d) {
                    if (d.listAble == "2") {
                        d.icon = "fa fa-ban";
                        //d.a_attr = {style:'background-color:#9088881f'};
                    }
                })
            }
        },
        showTreeRightPanel() {
            let me = this
            if (me.userInfo.developer || me.isSysAdmin() || me.userInfo.unitAdmin) {
                var contextMenu = PF.contextMenu({
                    el: me.$refs.deptTreePanelDiv,
                    target: '.mw-toolbar__body',
                    items: [{
                        text: "添加",
                        icon: "fa fa-plus",
                        handler: function() {
                            // me.mwRef('deptTreeData').unCheckAll()
                            me.addDepart(null, true);
                        }
                    }]
                });
                me.$on("hook:destroyed", function() { contextMenu.destroy() });
            }
        },
        showDeptUpload() {
            if (this.firstImpDeptOpen) {
                this.initUploader('dept');
                this.firstImpDeptOpen = false;
            }
        },
        initUserImg() {
            if (this.firstUserDialogOpen) {
                this.$nextTick(function() {
                    //if (!this.signUrl) {
                    this.initUserImgUploader('sign');
                    //} else {
                    this.initUserImgUploader('signPlus');
                    //  }
                    //if (!this.imageUrl)
                    this.initUserImgUploader('img');
                    //  else
                    this.initUserImgUploader('imgPlus');
                    this.firstUserDialogOpen = false;
                })
            }
        },
        initUserImgUploader(type) {
            let me = this;
            let btnId, params;
            let url = me.action;
            if (type == "img" || type == "imgPlus") {
                if (type == "img") {
                    btnId = me.mwRef('imgUploader').$el;
                } else {
                    btnId = me.mwRef('imgPlusUploader');
                }
                if (me.user.id) {
                    url = "/api/data/saveUserAvatar";
                    params = { userId: me.user.id };
                } else {
                    params = me.defaultParams;
                }
            } else if (type == "sign") {
                btnId = me.mwRef('signUploader').$el;
                params = me.signParams;
            } else if (type == "signPlus") {
                btnId = me.mwRef('signPlusUploader');
                params = me.signParams;
            }
            let cfg = {
                buttonId: btnId,
                maxSize: 500,
                action: url,
                title: "图片文件",
                accept: "jpg,jpeg,gif,png,bmp,tif",
                params: params
            }
            let fn = {
                uploadFile(up, file) {
                    if (type == "img" || type == "imgPlus") {
                        return me.beforeAvatarUpload(up, file);
                    } else if (type == "sign" || type == "signPlus") {
                        return me.beforeSignUpload(up, file);
                    }
                },
                fileUploaded(up, file, resp) {
                    if (type == "img" || type == "imgPlus")
                        me.handleAvatarSuccess(resp, file, up);
                    else if (type == "sign" || type == "signPlus")
                        me.handleSignSuccess(resp, file, up);
                }
            }
            PF.initPupload(cfg, fn);
        },
        initUploader(type) {
            let me = this;
            let btnId, action;
            if (type == "user") {
                btnId = me.mwRef('UserUploader').$el;
                action = me.importAction;
            } else {
                btnId = me.mwRef('DeptUploader').$el;
                action = me.importDeptAction;
            }

            let cfg = {
                buttonId: btnId,
                maxSize: 500,
                action: action,
                accept: "xls"
            }
            let fn = {
                fileUploaded(up, file, resp) {
                    if (type == "user")
                        me.importSuccessCallback(resp, file, up);
                    else
                        me.importDeptSuccessCallback(resp, file, up);
                }
            }
            PF.initPupload(cfg, fn);
        },
        aa(node, callback) {
            var menuItem = {};
            if (node.id === this.userInfo.loginDepartment.id) {
                menuItem = {
                    'item1': {
                        name: 'add',
                        icon: 'fa fa-plus-square',
                        label: '添加',
                        action: this.addDepart
                    },
                    'item2': {
                        name: 'edit',
                        label: '编辑',
                        icon: 'fa fa-pencil fa-fw',
                        action: this.editDept
                    },
                    'item3': {
                        name: 'delete',
                        label: '删除',
                        icon: 'fa fa-trash-o',
                        action: this.deleteDepartment
                    }
                }
            }
            callback(menuItem)
        },
        departmentFullNameFormatter: function(data) {
            if (data.ID) {
                return data.departmentFullName;
            } else {
                return data.departmentName;
            }
        },
        ageNum(newValue) {
            var age = "";
            if (!newValue) return "0";
            if (new Date().getMonth() > new Date(newValue).getMonth()) {
                age = new Date().getFullYear() - new Date(newValue).getFullYear();
            } else if (new Date().getMonth() == new Date(newValue).getMonth()) {
                if (new Date().getDate() >= new Date(newValue).getDate()) {
                    age = new Date().getFullYear() - new Date(newValue).getFullYear();
                } else {
                    age = new Date().getFullYear() - new Date(newValue).getFullYear() - 1;
                }
            } else {
                age = new Date().getFullYear() - new Date(newValue).getFullYear() - 1;
            }
            return age;
        },
        importDept() {
            let me = this;
            me.mwRef("importDeptData").submit();
        },
        importUser() {
            let me = this;
            me.mwRef("importData").submit();
        },
        isSysAdmin() {
            // if (this.userInfo.roleNames && this.userInfo.roleNames.indexOf("系统管理员") != -1) {//处理兼职情况下有系统管理员权限但是组织成员内容不展示
            if (this.userInfo.allIdentityRoleNames && this.userInfo.allIdentityRoleNames.indexOf("系统管理员") != -1) {
                return true;
            }
            return false;
        },
        importSuccessCallback(response, file, up) {
            if (response.result) {
                this.mwRef('deptTreeData').refresh();
                PF.show('message', { title: "导入信息", html: response.result[0].errMsg });
                this.mwRef('leadDialog').hide();
            }
            // this.mwRef("importData").clearFiles();
            if (this.mwRef("importData") && typeof this.mwRef("importData").clearFiles == "function") {
                this.mwRef("importData").clearFiles();
            } else if (up && up.files && up.files.length > 0 && typeof up.splice == "function") {
                up.splice(0, up.files.length);
            }
        },
        importDeptSuccessCallback(response, file, up) {
            if (response.result) {
                this.mwRef('deptTreeData').refresh();
                PF.show('message', { title: "导入信息", html: response.result.errMsg });
                this.mwRef('impDeptDialog').hide();
            }
            // this.mwRef("importDeptData").clearFiles();
            if (this.mwRef("importDeptData") && typeof this.mwRef("importDeptData").clearFiles == "function") {
                this.mwRef("importDeptData").clearFiles();
            } else if (up && up.files && up.files.length > 0 && typeof up.splice == "function") {
                up.splice(0, up.files.length);
            }
        },
        //部门导入导出
        handleDeptMoreCommand(command) {
            if (command === 'importDept') {
                this.mwRef('impDeptDialog').show();
            }
            if (command === 'exportDept') {
                //let deptIds=[this.checkedId];
                //this.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportDepartmentToExcel"),{},false,"");
                this.exportDept = true;
                this.mwRef('addDeptDialog1').show();
                this.initDeptDialog1Data();
            }
        },
        openAll() {
            this.mwRef('deptTree1').openAll();
        },
        checkAll() {
            this.openAll();
            this.mwRef('deptTree1').checkAll();
        },
        unCheckAll() {
            this.mwRef('deptTree1').unCheckAll();
        },
        //导出部门用户
        expChooseDeptUser() {
            let datas = this.mwRef('deptTree1').getSelected();
            let ids = datas.map((v) => { return v.id });
            let params = { deptIds: ids };
            if (this.exportDept) {
                this.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportDepartmentToExcel"), {}, false, PF.encode(params));
            } else {
                this.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportDepartmentUserToExcel"), {}, false, PF.encode(params));
            }
            this.mwRef('addDeptDialog1').hide();
        },
        // 部门用户导入导出
        handleMoreCommand(command) {
            if (command === 'leadIn') {
                this.mwRef('leadDialog').show();
            } else if (command === 'leadOut') {
                this.exportDept = false;
                let dataTable = this.mwRef('dataTable');
                let multipleSelection = dataTable.getMultipleSelection();
                if (multipleSelection && multipleSelection.length > 0) {
                    let userIds = [];
                    let deptIds = {};
                    multipleSelection.forEach((val) => {
                        userIds.push(val.userId || val.id);
                        deptIds[val.userId || val.id] = (val.departmentId);
                    });
                    this.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportDepartmentUserToExcel"), {}, false, PF.encode({ userIds: userIds, deptIds: deptIds }));
                } else {
                    this.mwRef('addDeptDialog1').show();
                    this.initDeptDialog1Data();
                }
            } else if (command === 'removeip') {
                this.removeIp(1);
            } else if (command === 'bindip') {
                this.bindUserIp();
            }
        },
        handOverCommand(command) {
            if (command === 'todo') {
                this.handOverTodoForm = {
                    assigned: '',
                    assignedId: '',
                    recipient: '',
                    recipientId: ''
                };
                this.mwRef('handOverTodo').show();
            } else if (command === 'finish') {
                this.handOverFinishForm = {
                    assigned: '',
                    assignedId: '',
                    recipient: '',
                    recipientId: '',
                    startTime: '',
                    endTime: '',
                    moduleName: '',
                    moduleId: ''
                };
                this.mwRef('handOverFinish').show();
            }
        },
        initDeptDialog1Data() {
            if (this.init1) {
                this.mwRef('addDeptDialog1').$nextTick(() => {
                    this.mwRef('deptTree1').refresh();
                })
            }
            this.init1 = false;
        },
        doOrderDepartments: function(data, dept) {
            var me = this;
            var n = data.position + 1;
            var departmentSns = [];
            departmentSns.push(dept.id + ',' + n);
            me.mwApi.org.listDepartmentAndCount(dept.parentId).then(function(res) {
                res.result.forEach(function(r, index) {
                    if (r.id === dept.id) {
                        if (data.position > index) {
                            for (var i = 0; i < index; i++) {
                                var no = i + 1;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                            for (var i = index + 1; i <= data.position; i++) {
                                var no = i;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                            for (var i = data.position + 1; i < res.result.length; i++) {
                                var no = i + 1;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                        }
                        if (data.position < index) {
                            for (var i = 0; i < data.position; i++) {
                                var no = i + 1;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                            for (var i = data.position; i < index; i++) {
                                var no = i + 2;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                            for (var i = index + 1; i < res.result.length; i++) {
                                var no = i + 1;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                        }
                        if (data.position === index) {
                            for (var i = index + 1; i < res.result.length; i++) {
                                var no = i + 1;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                        }
                    }
                })
                me.mwApi.org.orderDepartments(departmentSns);
            })
        },
        moveTreeNode(e, data) {
            let me = this;
            let dept = {};
            dept.id = data.node.id;
            dept.parentId = data.node.parent;
            dept.parentName = this.mwRef('deptTreeData').getNode(data.node.parent).text;
            if (dept.parentName) {
                dept.parentName = dept.parentName.substring(0, dept.parentName.lastIndexOf('('));
            }
            if (dept.parentId === '#') {
                dept.parentId = '';
            }
            dept.name = data.node.original.name.substring(0, data.node.original.name.indexOf('('));
            //部门parentId一样就不保存，保存会影响排序，导致往下拖一直拖不下来
            if (data.old_parent == data.parent) {
                me.doOrderDepartments(data, dept);
            } else {
                this.mwApi.org.saveDepartment(dept).then(function(resu) {
                    if (resu.success) {
                        me.doOrderDepartments(data, dept);
                    }
                })
            }
        },

        handleAvatarSuccess(response, file, fileList) {
            if (!this.user.id && response.result) {
                this.user.avatarAttachId = response.result['#items'][0].id;
            }
            if (this.fileList.length > 0) {
                let ids = [];
                this.fileList.forEach(f => {
                    ids.push(f.id)
                });
                let params = Object.assign({ attachIds: ids }, this.defaultParams);
                this.mwApi.business.deleteAttachment(params).then(res => {
                    if (res.success) {
                        this.refreshPic(this.defaultParams)
                    }
                });
            } else {
                this.refreshPic(this.defaultParams);
            }
        },

        beforeAvatarUpload(up, file) {
            let a = true;
            if (this.user.id) {
                this.defaultParams.id = this.user.id;
                a = true;
            } else if (this.user.loginId) {
                this.defaultParams.type = this.user.loginId;
                this.defaultParams.fullPath = true;
                a = true;
            } else {
                this.mwMsg('请输入登录账号名');
                up.removeFile(file);
                a = false;
            };
            return a;
        },

        beforeSignUpload(up, file) {
            let a = true;
            if (this.user.loginId) {
                this.signParams.type = this.user.loginId;
                this.signParams.businessId = this.user.loginId;
                this.signParams.formId = this.user.loginId;
                this.signParams.tempBusinessId = this.user.loginId;
                this.signParams.fullPath = true;
                a = true;
            } else {
                this.mwMsg('请输入登录账号名');
                up.removeFile(file);
                a = false;
            };
            return a;
        },

        handleSignSuccess(response, file, fileList) {
            if (this.fileSignList.length > 0) {
                let ids = [];
                this.fileSignList.forEach(f => {
                    ids.push(f.id)
                });
                let params = Object.assign({ attachIds: ids }, this.signParams);
                this.mwApi.business.deleteAttachment(params).then(res => {
                    if (res.success) {
                        this.refreshSign(this.signParams)
                    }
                });
            } else {
                this.refreshSign(this.signParams);
            }
        },

        remove(file) {

            $(".sign").click(function(event) {
                event.preventDefault();
            });
            let params = Object.assign({ attachIds: [file.id] }, this.signParams);
            this.mwApi.business.deleteAttachment(params).then(res => {
                if (res.success) {
                    this.refreshSign(this.signParams);
                    $(".sign").unbind('click');
                }
            });
        },

        removePic(file, flag) {
            $(".headImg").click(function(event) {
                event.preventDefault();
            });
            if (this.user.id && flag == "avatar") {
                this.mwUtil.ajax(PF.getApplicationPath() + "/api/data/removeUserAvatar", { userId: this.user.id }).then(res => {
                    if (res.success) {
                        this.refreshPic(this.defaultParams);
                        $(".headImg").unbind('click');

                    }
                })
            } else {
                let params = Object.assign({ attachIds: [file.id] }, this.defaultParams);
                this.mwApi.business.deleteAttachment(params).then(res => {
                    if (res.success) {
                        if (flag == "avatar") {
                            this.user.avatarAttachId = "";
                        }
                        this.refreshPic(this.defaultParams);
                        $(".headImg").unbind('click');
                    }
                });
            }

        },
        refreshSign() {
            this.mwApi.business.listAttachment(this.signParams).then(res => {
                let params = this.signParams;
                this.fileSignList = res.result || [];
                if (this.fileSignList.length > 0) {
                    let string = 'id=' + res.result[0].id + '&businessId=' + params.businessId + '&formId=' + params.formId + '&tempBusinessId=' + params.tempBusinessId + '&xToken=' + token.getToken();
                    this.signUrl = this.mwUrl("/api/business/downloadAttachment?") + string;
                } else {
                    this.signUrl = ''
                }
            })
        },
        refreshPic() {
            if (this.user.id) {
                this.mwUtil.ajax(PF.getApplicationPath() + "/api/data/hasUserAvatar", { userId: this.user.id }).then(res => {
                    if (res.result) {
                        this.imageUrl = PF.getApplicationPath() + "/api/data/getUserAvatar?userId=" + this.user.id + "&t=" + Date.now();
                    } else {
                        this.imageUrl = ''
                    }
                })
            } else {
                this.mwApi.business.listAttachment(this.defaultParams).then(res => {
                    let params = this.defaultParams;
                    this.fileList = res.result || [];
                    if (this.fileList.length > 0) {
                        let string = 'id=' + res.result[0].id + '&businessId=' + params.businessId + '&formId=' + params.formId + '&tempBusinessId=' + params.tempBusinessId + '&xToken=' + token.getToken();
                        this.imageUrl = this.mwUrl("/api/business/downloadAttachment?") + string;
                    } else {
                        this.imageUrl = ''
                    }
                });
            }
        },
        downloadAttachment(data, params) {
            if (params.flag == 'avatar' && this.user.id) {
                this.mwUtil.downloadAttachment(this.mwUrl("/api/data/getUserAvatar"), {}, false, PF.encode({ userId: this.user.id, flag: "download" }));
            } else {
                params.id = data.id;
                this.mwApi.business.downloadAttachment(params);
            }
        },
        loadTableTree(data) {
            if (!this.isSysAdmin() && !(this.userInfo.unitAdmin) && this.userInfo.departmentAdmin) {
                if (data.id === this.userInfo.loginDepartment.id) {
                    this.isLimit = false;
                    let btns = [{
                            label: '添加',
                            icon: 'fa fa-plus-square',
                            func: this.addUser
                        },
                        {
                            label: '删除',
                            icon: 'fa fa-trash-o fa-fw',
                            func: this.deleteUser
                        }
                    ];
                    if (this.buttons.length > 0) {
                        this.buttons.splice(0, this.buttons.length)
                    }
                    btns.forEach(item => {
                        this.buttons.push(item);
                    })

                } else {
                    this.isLimit = true;
                    if (this.buttons.length > 0) {
                        this.buttons.splice(0, this.buttons.length)
                    }
                }
            }
            if (!this.isSysAdmin() && !this.userInfo.ownerAdmin && this.userInfo.unitAdmin) {
                this.buttons.splice(2, 1)
            }
            if (this.mwRef('dataTable').mwRef('dataTable').filters.filter && this.mwRef('dataTable').mwRef('dataTable').filters.filter.qcon) {
                this.mwRef('dataTable').mwRef('dataTable').filters.filter.qcon = '';
            }
            this.refreshTable(data.id, function() {});
            this.checkedId = data.id;
            this.nodeText = data.text.substring(0, data.text.indexOf('('));
        },
        refreshTable(checkedId, callback) {
            var tableDefaultParams = this.mwRef('dataTable').defaultParams;
            tableDefaultParams.departmentId = checkedId;
            //this.mwRef('dataTable').refreshTableDefaultParams(tableDefaultParams);
            this.mwRef('dataTable').refreshTable();
            if (typeof callback === 'function') {
                this.mwRef('dataTable').clearSelection();
            }
        },

        adminFormatter(data) {
            if (data.isAdmin) {
                return ('< i class = "fa fa-user" title = "管理员" > < /i>')
            }
        },

        deleteDepartment(dept) {
            if (!dept.id) {
                if (this.mwRef('deptTreeData').getSelected()) {
                    dept = this.mwRef('deptTreeData').getSelected();
                } else {
                    me.mwMsg('请选择要删除的节点!');
                }
            }
            let a = false;
            if (dept.hasChild > 0) {
                a = true;
            } else {
                a = false;
            }
            let me = this;
            var pos = me.deptTreeUrl.indexOf("?t");

            if (a) {
                this.$confirm('此节点下有多个子节点, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    me.mwApi.org.deleteDepartment([dept.id]).then(data => {
                        if (pos != -1) {
                            me.deptTreeUrl = me.deptTreeUrl.substring(0, pos) + "?t=" + Date.now();
                        } else {
                            me.deptTreeUrl = me.deptTreeUrl += "?t=" + Date.now();
                        }
                        if (data.success) {
                            me.mwMsg('删除成功!');
                            me.mwRef('deptTreeData').refresh();
                            me.loadTableTree(dept);
                        } else {
                            me.mwMsg('info', '删除失败!');
                        }

                    })
                })
            } else {
                this.$confirm('您确定要删除此节点', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    me.mwApi.org.deleteDepartment([dept.id]).then(data => {
                        if (pos != -1) {
                            me.deptTreeUrl = me.deptTreeUrl.substring(0, pos) + "?t=" + Date.now();
                        } else {
                            me.deptTreeUrl = me.deptTreeUrl += "?t=" + Date.now();
                        }
                        if (data.success) {
                            me.mwMsg('删除成功!');
                            me.mwRef('deptTreeData').refresh();
                            me.loadTableTree(dept);
                        } else {
                            me.mwMsg('info', '删除失败!');
                        }
                    })
                }).catch(() => {})
            }
        },
        // 部门操作
        expand() {
            this.expandFlag = 2;
            this.mwRef('deptTreeData').openAll();
        },
        closed() {
            this.expandFlag = 1;
            this.mwRef('deptTreeData').closeAll();
        },
        //保存新建部门信息
        saveDept() {
            let me = this;
            this.mwRef('ruleForm').validate((valid) => {
                if (valid) {
                    if (!this.edit) {
                        this.dept.parentId = this.dept.parentId ? this.checkedId : '<ROOT>';
                        this.dept.parentName = this.dept.parentName ? this.nodeText : '<ROOT>';
                    } else {
                        if (!this.dept.parentId) {
                            this.dept.parentId = '<ROOT>';
                            this.dept.parentName = '<ROOT>';
                        }
                    }
                    this.mwApi.org.saveDepartment(this.dept).then(data => {
                        var pos = me.deptTreeUrl.indexOf("?t");
                        if (pos != -1) {
                            me.deptTreeUrl = me.deptTreeUrl.substring(0, pos) + "?t=" + Date.now();
                        } else {
                            me.deptTreeUrl = me.deptTreeUrl += "?t=" + Date.now();
                        }
                        if (data.success) {
                            this.mwMsg('保存成功')
                            this.mwRef('deptTreeData').refresh();
                            this.mwRef('deptDialog').hide();
                            this.mwRef('ruleForm').resetFields();
                        }
                    })
                } else {
                    this.mwMsg('信息未填写完整');
                }
            });
        },
        closeDeptDialog() {
            this.mwRef('deptDialog').hide();
            this.mwRef('ruleForm').resetFields();
        },
        addDepart(data, addRoot) {
            // this.addRoot = false;
            this.edit = false;
            if ((!addRoot || addRoot !== true) && this.mwRef('deptTreeData').getTreeData().length > 0) {
                if (!this.mwRef('deptTreeData').getSelected()) {
                    this.mwMsg('请选中你要操作的部门或单位');
                } else {
                    let nodeText = this.nodeText.substring(0, this.nodeText.indexOf('(')) || '';
                    this.mwApi.org.getDepartment(this.checkedId).then(data => {
                        var flag;
                        if (data.result.flag && data.result.flag != 1) {
                            flag = '3';
                        }
                        this.dept = {
                            name: '',
                            shortname: '',
                            Englishname: '',
                            id: '',
                            flag: flag || '2',
                            adminName: '',
                            adminId: '',
                            sn: '',
                            listAble: '1',
                            parentId: this.checkedId,
                            parentName: this.nodeText,
                            identityIds: '',
                            code: ''
                        };
                    });
                    this.mwRef('deptDialog').show();
                }
            } else {
                this.dept = {
                    name: '',
                    shortname: '',
                    Englishname: '',
                    id: '',
                    flag: '1',
                    adminName: '',
                    adminId: '',
                    sn: '',
                    listAble: '1',
                    identityIds: '',
                    code: ''
                };
                this.mwRef('deptDialog').show();
            }

        },
        editDept() {
            if (!this.mwRef('deptTreeData').getSelected()) {
                this.mwMsg('请选择你要编辑的部门');
            } else {
                this.edit = true;
                this.mwApi.org.getDepartment(this.checkedId).then(res => {
                    if (res.success) {
                        this.dept = {
                            id: '',
                            name: '',
                            shortname: '',
                            Englishname: '',
                            flag: '1',
                            adminName: '',
                            adminId: '',
                            sn: '',
                            listAble: '1',
                            identityIds: '',
                            code: ''
                        };
                        if (res.result.parentId) {
                            this.dept.parentId = '';
                            this.dept.parentName = '';
                        }
                        this.mwUtil.applyCover(this.dept, res.result);
                        if (res.result.parentId) {
                            if (this.dept.parentName.indexOf('(') != -1) {
                                this.dept.parentName = this.dept.parentName.substring(0, this.dept.parentName.indexOf('('));
                            }
                        }
                        this.mwRef('deptDialog').show();
                    }
                })
            }
        },
        removeIp(type) {
            let userIds = [];
            if (type && type == "1") { //视图批量解除绑定IP
                let multipleSelection = this.mwRef('dataTable').getMultipleSelection();
                let isCanAddUser = true;
                multipleSelection.forEach(r => {
                    if (r.id) {
                        userIds.push(r.id);
                    } else if (r.ID) {
                        userIds.push(r.ID);
                    }

                })
            } else if (type && type == "2") { //人员信息里面点击解除绑定IP
                userIds.push(this.user.id);
            }
            if (userIds.length == 0) {
                this.mwMsg('info', '请选择你需要操作的用户')
            } else {
                this.$confirm('是否解除ip绑定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.mwApi.org.clearUserbindIp(userIds).then(res => {
                        if (res.result) {
                            this.user.bindIP = '';
                            this.mwMsg('success', '解除ip成功');
                        }
                    })
                }).catch(() => {});
            }
        },
        // 角色操作
        handleRoleCommand(command) {
            // 查看角色
            if (command == 'a') {
                this.roleLookUp();
            }
        },
        roleLookUp() {
            let multipleSelection = this.mwRef('dataTable').getMultipleSelection();
            let len = multipleSelection.length - 1;
            if (multipleSelection.length != 1) {
                this.mwMsg('info', '请选择一个用户进行操作');
            } else {
                let userId = multipleSelection[len].userId || multipleSelection[len].id
                this.mwApi.org.getDepartmentTypeIdentity(multipleSelection[len].departmentId, 'DEP_USER', userId).then(data => {
                    this.userIdentityId = data.result.id;
                    this.identityId = this.userIdentityId;
                    this.mwRef('userRoleDialog').show();
                    this.userInfo1 = [{ id: this.userIdentityId, name: multipleSelection[len].name, departmentId: multipleSelection[len].departmentId, isLimit: this.isLimit }];
                });
            }
        },
        chooseSure(a) {
            this.mwRef(a).show();
        },
        cancel(a) {
            this.mwRef(a).hide();
        },

        bindSec() {
            if (this.secFirst) {
                this.mwRef('chooseSec').refresh();
            }
            this.chooseSure('chooseSec');
            this.secFirst = true;
        },
        showMenu() {

        },

        // 选择岗位
        confirmPost(data) {
            this.cancel('choosePost');
            this.user.position = data;
        },

        // 选择秘书
        confirmSec() {
            let data = this.mwRef('chooseSec').getValue();
            this.user.secretary = data[0].name;
            this.user.secretaryId = data[0].id;
        },

        //二类级别
        confirmTwoRand(data) {
            this.user.secondRank = '';
            this.user.secondRankId = '';
            let secondRank = [];
            let secondRankId = []
            data.forEach(d => {
                secondRank.push(d.id);
                secondRankId.push(d.name)
            });
            this.user.secondRank = secondRank.join();
            this.user.secondRankId = secondRankId.join();
        },


        //部门操作
        handleDeptCommand(command) {
            this.ismultiple = false;
            let data = this.mwRef('dataTable').getMultipleSelection();
            if (data.length == 0) {
                this.mwMsg('请选择你要操作的用户');
            } else {
                this.mwRef('addDeptDialog').show();
                if (this.init) {
                    this.mwRef('addDeptDialog').$nextTick(() => {
                        this.mwRef('deptTree').refresh();
                    })
                }
                this.init = false;

                if (command == 'add') {
                    this.addUserDept = true;
                } else {
                    this.addUserDept = false;
                }
            }


        },

        addUser() {

            if (!this.firstUserOpen) {
                this.mwRef('userForm').resetFields();
            }

            this.firstUserOpen = false;

            if (this.mwRef('deptTreeData').getSelected().length === 0) {
                this.mwMsg('info', '请选择部门再添加用户');
            } else {

                this.mwApi.org.getDepartment(this.checkedId).then(data => {
                    this.user = {
                        departmentId: this.checkedId,
                        loginId: '',
                        name: '',
                        sex: '1',
                        initial: '',
                        pinyin: '',
                        Englishname: '',
                        password: '',
                        email: '',
                        label: '',
                        id: '',
                        staffId: '',
                        departmentName: data.result.name,
                        sn: '',
                        phone: '',
                        mobile: '',
                        position: '',
                        secretary: '',
                        secretaryId: '',
                        jobs: '',
                        isSecret: '1',
                        timeOfJoinInWork: '',
                        workyear: '',
                        edu: '',
                        birth: '',
                        mjbs: '',
                        age: '',
                        idNumber: '',
                        weiChatNum: '',
                        userLevel: '',
                        listAble: '1',
                        roleNames: '',
                        roleid: '',
                        persontype: '1',
                        departmentIdentityId: '',
                        companyEmail: '',
                        zgdept: '',
                        zgdeptid: '',
                        staffLevel: '',
                        secondRank: '',
                        thirdRank: '',
                        firstLevelDept: '',
                        firstLevelDeptId: '',
                        secondLevelDept: '',
                        secondLevelDeptId: '',
                        thirdLevelDept: '',
                        thirdLevelDeptId: '',
                        primaryDepartmentName: data.result.name,
                        primaryDepartmentId: data.result.id
                    };
                    this.signUrl = '';
                    this.imageUrl = '';
                    this.editUser = false;
                    this.mwRef('userAddDialog').show();
                });

            }

        },
        deleteUser(data) {
            let me = this;
            if (data.length == 0) {
                this.mwMsg('info', '请选择你要操作的用户');
                return;
            }
            this.$confirm('确定要删除该部门用户?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let depUsersMap = {};
                data.forEach((val) => {
                    if (!depUsersMap[val.departmentId]) depUsersMap[val.departmentId] = [];
                    depUsersMap[val.departmentId].push({ id: val.userId || val.id, name: val.name, identityId: val.identityId });
                });
                let p;
                _.each(depUsersMap, function(vals, k) {
                    let arrIds = [];
                    vals.forEach((v) => {
                        arrIds.push(v.id);
                    })
                    if (!p) {
                        p = me.mwApi.org.deleteDepartmentUser(k, arrIds);
                    } else {
                        p = p.then(data => {
                            return me.mwApi.org.deleteDepartmentUser(k, arrIds);
                        })
                    }
                });
                p.then(data => {
                    if (data.success) {
                        me.mwMsg('删除成功!');
                        me.mwRef('deptTreeData').refresh();
                    } else {
                        me.mwMsg('info', '删除成功!');
                    }
                })
            });
        },
        changeTreeData(data) {
            data.forEach(d => {
                d.label = d.name;
                if (d.children && d.children.length > 0) {
                    this.changeTreeData(d.children);
                }
            })
        },

        dbHandleRow(row, index) {
            let id = row.ID || row.id; //搜索转大写，要不然兼职人员视图显示会报错
            this.mwApi.org.getUser(id).then(res => {
                if (res.success) {
                    this.user = {
                        id: '',
                        departmentId: '',
                        loginId: '',
                        name: '',
                        sex: '1',
                        initial: '',
                        pinyin: '',
                        Englishname: '',
                        password: '',
                        email: '',
                        label: '',
                        staffId: '',
                        departmentName: '',
                        childDept: '',
                        childDeptId: '',
                        sn: '',
                        phone: '',
                        persontype: '1',
                        mobile: '',
                        position: '',
                        secretary: '',
                        secretaryId: '',
                        jobs: '',
                        isSecret: '1',
                        timeOfJoinInWork: '',
                        workyear_: '',
                        edu: '',
                        birth: '',
                        age: '',
                        idNumber: '',
                        weiChatNum: '',
                        userLevel: '',
                        listAble: '1',
                        roleNames: '',
                        roleid: '',
                        departmentIdentityId: '',
                        companyEmail: '',
                        zgdept: '',
                        zgdeptid: '',
                        staffLevel: '',
                        secondRank: '',
                        thirdRank: '',
                        firstLevelDept: '',
                        firstLevelDeptId: '',
                        secondLevelDept: '',
                        secondLevelDeptId: '',
                        thirdLevelDept: '',
                        thirdLevelDeptId: '',
                        primaryDepartmentName: '',
                        primaryDepartmentId: '',
                        bindIP: '',
                        mjbs: ''
                    };
                    this.mwRef('userAddDialog').show();
                    var departmentId = row.departmentId || this.checkedId;
                    this.mwUtil.applyCover(this.user, res.result);
                    if (res.result.positions && res.result.positions[departmentId]) {
                        this.user.position = res.result.positions[departmentId];
                    }
                    if (res.result.data) {
                        var data = JSON.parse(res.result.data);
                        this.user.bindIP = (data.bindIP) ? data.bindIP : "";
                    }
                    this.user.sn = row.sn;
                    this.user.workyear_ = this.ageNum(row.timeOfJoinInWork);
                    this.user.departmentId = departmentId;
                    this.user.departmentName = this.nodeText;
                    this.defaultParams.type = this.user.loginId;
                    this.signParams.type = this.user.loginId;
                    this.signParams.businessId = this.user.loginId;
                    this.signParams.formId = this.user.loginId;
                    this.signParams.tempBusinessId = this.user.loginId;
                    this.refreshPic();
                    this.refreshSign();
                    this.editUser = true;

                    this.mwApi.org.getDepartmentTypeIdentity(departmentId, 'DEP_USER', id).then(datas => {
                        this.userIdentityId = datas.result.id;
                        this.user.departmentName = datas.result.departmentName || this.nodeText;
                    });
                }
            })
        },

        cancelChoose() {
            this.mwRef('addDeptDialog').hide();
        },
        cancelChoose1() {
            this.mwRef('addDeptDialog1').hide();
        },

        //为用户追加或者转换部门
        addUsersDept() {
            let me = this;
            this.user.departmentId = this.mwRef('deptTree').getSelected().id;
            let userIds = [];
            let multipleSelection = this.mwRef('dataTable').getMultipleSelection();
            let isCanAddUser = true;
            multipleSelection.forEach(r => {
                if (r.departmentId == me.user.departmentId) {
                    me.mwMsg('info', '该用户已是该部门成员,无须重复添加');
                    isCanAddUser = false;
                    return;
                }
                userIds.push(r.userId || r.id);
            })
            if (!isCanAddUser) return;
            this.mwApi.org.addDepartmentUser(this.user.departmentId, userIds).then(data => {
                if (data.success) {
                    this.mwMsg('追加成功!');
                    this.cancelChoose();
                } else {
                    this.mwMsg('info', '追加失败!');
                }
            });
        },

        addTransUserDept() {
            if (this.addUserDept) {
                this.addUsersDept();
            } else {
                this.tansUserDept();
            }
        },
        //为用户转换部门
        tansUserDept() {
            let me = this;
            let toDepartmentId = this.mwRef('deptTree').getSelected().id;
            let depUsersMap = {};
            let isCanTans = true;
            let data = this.mwRef('dataTable').getMultipleSelection();
            if (!data || data.length === 0) {
                this.mwMsg('info', '请选择转换用户')
                return;
            }
            data.forEach((val) => {
                if (toDepartmentId === val.departmentId) {
                    this.mwMsg('info', '该用户已是该部门成员,无须转换')
                    isCanTans = false;
                    return;
                }
                if (!depUsersMap[val.departmentId]) depUsersMap[val.departmentId] = [];
                depUsersMap[val.departmentId].push({ id: val.userId || val.id, name: val.name, identityId: val.identityId });
            });
            if (!isCanTans) return;
            let p;
            _.each(depUsersMap, function(vals, k) {
                let userIds = [];
                vals.forEach((v) => {
                    userIds.push(v.id);
                })
                if (!p) {
                    p = me.mwApi.org.changeDepartmentUser(k, toDepartmentId, userIds)
                } else {
                    p = p.then(data => {
                        return me.mwApi.org.changeDepartmentUser(k, toDepartmentId, userIds)
                    })
                }
            });
            p.then(data => {
                this.mwMsg('转换部门成功!');
                this.cancelChoose();
                this.mwRef('deptTreeData').refresh();
            })
        },
        handleManage(data) {
            if (data.length == 0) {
                this.mwMsg('info', '请选择你要操作的数据')
            } else {

                data.forEach(t => {
                    if (t.isAdmin) {
                        this.mwApi.org.deleteOwnerAdminUser(t.id)
                    } else {
                        this.mwApi.org.addOwnerAdminUser(t.id)
                    }
                });
                this.refreshTable(this.checkedId, function() {});
            }
        },
        //关闭新建用户对话框
        closeUserDialog() {
            this.mwRef('userAddDialog').hide();
            this.mwRef('userForm').resetFields();
        },

        //创建新用户
        newUser() {
            this.mwRef('userForm').validate((valid) => {
                if (valid) {
                    this.user.signUrl = this.signUrl;
                    this.user.imageUrl = this.imageUrl;
                    this.mwApi.org.saveUser(this.user).then(data => {
                        if (data.success) {
                            this.mwMsg('保存成功');
                            this.mwRef('userAddDialog').hide();
                            this.closeUserDialog();
                            this.mwRef('deptTreeData').refresh();
                            // this.refreshTable(this.checkedId);
                        }
                    })
                } else {
                    this.mwMsg('warninPF.getRouterg', '信息未填写完整');
                }
            });
        },
        processSelRowData() {
            let me = this;
            this.mwRef('dataTable').$on("dataLoaded", function(datas) {
                me._currTableAllRecords = datas;
                let records = me.mwRef('dataTable').getMultipleSelection();
                if (records && records.length > 0) {
                    let row = records[0];
                    _.each(datas, function(v) { if (v.id == row.id || v.userId == row.userId) row = v; })
                    me.mwRef('dataTable').clearSelection();
                    me.mwRef('dataTable').toggleRowSelection(row, true);
                }
            })
        },
        //排序
        handleSortCommand(command) {
            let me = this;
            let multipleSelection = this.mwRef('dataTable').getMultipleSelection();
            if (command === 'sort') {
                let a = '1234';
                this.mwApi.org.orderDepartmentUsers(this.checkedId).then(res => {
                    this.refreshTable(this.checkedId, a, function(a) {
                    });
                })
                return;
            }
            if (!multipleSelection || multipleSelection.length != 1) {
                this.mwMsg('请选择一个用户');
                return;
            }
            if (command === 'top') {
                if (multipleSelection && multipleSelection.length > 0) {
                    this.mwApi.org.orderUserTop(multipleSelection[0].id, this.checkedId).then(res => {
                        if (res.result) {
                            this.refreshTable(this.checkedId);
                        }
                    })
                } else {
                    this.mwMsg('请选择你要操作的用户')
                }
            };

            if (command === 'footer') {
                if (multipleSelection && multipleSelection.length > 0) {
                    this.mwApi.org.orderUserLow(multipleSelection[0].id, this.checkedId).then(res => {
                        if (res.result) {
                            this.refreshTable(this.checkedId);
                        }
                    })
                } else {
                    this.mwMsg('请选择你要操作的用户')
                }

            };

            if (command == 'down') {

                if (multipleSelection && multipleSelection.length > 0) {
                    let userSns = [];
                    let len = multipleSelection.length - 1;
                    this.mwApi.org.listDepartmentUserPaging({ departmentId: this.checkedId, start: 0, limit: 100000 }).then(res => {
                        if (res.success && res.totalCount > 1) {
                            res.result.forEach((r, index) => {
                                if (r.id === multipleSelection[0].id && index != res.totalCount - 1) {
                                    let name2 = res.result[index + 1].id + ',' + multipleSelection[len].sn;
                                    let name1 = multipleSelection[len].id + ',' + res.result[index + 1].sn;
                                    userSns.push(name1);
                                    userSns.push(name2);
                                    this.mwApi.org.orderUsers(userSns, this.checkedId).then(data => {
                                        if (data.success) {
                                            this.refreshTable(this.checkedId)
                                        }
                                    })
                                    return;
                                }
                            })
                        }
                    })
                } else {
                    this.mwMsg('请选择你要操作的用户')
                }
            }

            if (command == 'up') {
                if (multipleSelection && multipleSelection.length > 0) {
                    let len = multipleSelection.length - 1;
                    let userSns = [];
                    this.mwApi.org.listDepartmentUserPaging({ departmentId: this.checkedId, start: 0, limit: 100000 }).then(res => {
                        if (res.success && res.totalCount > 1) {
                            res.result.forEach((r, index) => {
                                if (r.id === multipleSelection[0].id && index != 0) {
                                    let name2 = res.result[index - 1].id + ',' + multipleSelection[len].sn;
                                    let name1 = multipleSelection[len].id + ',' + res.result[index - 1].sn;
                                    userSns.push(name1);
                                    userSns.push(name2);
                                    this.mwApi.org.orderUsers(userSns, this.checkedId).then(data => {
                                        if (data.success) {
                                            this.refreshTable(this.checkedId);
                                        }
                                    })
                                    return;
                                }
                            })
                        }
                    })
                } else {
                    this.mwMsg('请选择你要操作的用户')
                }
            }
        },
        showChooseAdminDialog() {
            this.mwRef('userDialog').show();
            this.mwApi.org.getUnitById(this.checkedId).then(res => {
                this.defaultParentId = res.result.id;
                this.deptManagers = [];
                if (!this.firstTime) {
                    this.mwRef('chooseMangers').refreshTree(true);
                }
                this.firstTime = false;

                if (this.dept.adminId) {
                    let names = this.dept.adminName.split(',');
                    let ids = this.dept.adminId.split(',');
                    let identityIds = this.dept.identityIds.split(',');
                    for (let i = 0; i < names.length; i++) {
                        this.deptManagers.push({
                            id: ids[i],
                            name: names[i],
                            //identityId: identityIds[i]
                        })
                    }
                }
            });
        },
        chooseAdminSure() {
            this.dept.adminName = '';
            this.dept.adminId = '';
            this.dept.identityIds = '';
            let adminName = [];
            let adminId = [];
            let identityIds = [];
            this.mwRef('userDialog').hide();
            let data = this.mwRef('chooseMangers').getValue();
            data.forEach(d => {
                adminName.push(d.name);
                adminId.push(d.id);
                identityIds.push(d.identityId);
            });
            this.dept.adminName = adminName.join();
            this.dept.adminId = adminId.join();
            this.dept.identityIds = identityIds.join();

        },
        cancelChooseAdmin() {
            this.mwRef('userDialog').hide();
        },
        clearMan() {
            this.dept.adminName = '';
            this.dept.adminId = '';
            this.dept.identityIds = '';
        },
        findRoles() {
            if (this.user.id) {
                this.mwRef('userRoleDialog').show();
                this.identityId = this.userIdentityId;
                this.userInfo1 = [{ id: this.userIdentityId, name: this.user.name, departmentId: this.user.departmentId, isLimit: this.isLimit }];
            } else {
                this.mwMsg('info', "新建用户没有角色");
            }

        },
        closeRoleDialog() {
            this.refreshTable(this.checkedId)
            this.mwRef('userRoleDialog').hide();
        },
        clearStaLevel() {
            this.user.staffLevel = '';
        },
        clearseaLevel() {
            this.user.secondRank = '';
        },
        //三类级别
        cthirdLevel(data) {
            this.info3 = false;
            let thirdRank = [];

            data.forEach(d => {
                thirdRank.push(d);
            });

            this.user.thirdRank = thirdRank.join();

        },
        clearSec() {
            this.user.secretary = '';
            this.user.secretaryId = '';
        },
        canclethirdLevel() {
            this.info3 = false;
        },
        clearLevel() {
            this.user.thirdRank = '';
        },
        employLevel(data) {
            this.user.staffLevel = data;
        },
        //一级单位
        firstDeptChoose(data) {
            this.user.firstLevelDept = '';
            this.user.firstLevelDeptId = '';
            let firstLevelDept = [];
            let firstLevelDeptId = [];
            for (let i = 0; i < data.length; i++) {
                firstLevelDept.push(data[i].name);
                firstLevelDeptId.push(data[i].id);
            }
            this.user.firstLevelDept = firstLevelDept.join();
            this.user.firstLevelDeptId = firstLevelDeptId.join();
        },
        clearfirstDept() {
            this.user.firstLevelDept = '';
            this.user.firstLevelDeptId = ''
        },
        secondDeptChoose(data) {

            let secondLevelDept = [];
            let secondLevelDeptId = [];

            this.user.secondLevelDept = '';
            this.user.secondLevelDeptId = '';

            for (let i = 0; i < data.length; i++) {
                secondLevelDept.push(data[i].name);
                secondLevelDeptId.push(data[i].id);
            }
            this.user.secondLevelDept = secondLevelDept.join();
            this.user.secondLevelDeptId = secondLevelDeptId.join();
        },


        clearsecondDept() {
            this.user.secondLevelDept = '';
            this.user.secondLevelDeptId = '';
        },

        thirdDeptChoose(data) {

            this.user.thirdLevelDept = '';
            this.user.thirdLevelDeptId = '';
            let thirdLevelDept = [];
            let thirdLevelDeptId = [];
            for (let i = 0; i < data.length; i++) {
                thirdLevelDept.push(data[i].name);
                thirdLevelDeptId.push(data[i].id);
            }
            this.user.thirdLevelDept = thirdLevelDept.join();
            this.user.thirdLevelDeptId = thirdLevelDeptId.join();
        },

        clearthirdDept() {
            this.user.thirdLevelDept = '';
            this.user.thirdLevelDeptId = ''
        },

        zgdeptChoose(data) {

            this.user.zgdept = '';
            this.user.zgdeptid = '';
            let zgdept = [];
            let zgdeptIds = [];
            for (let i = 0; i < data.length; i++) {
                zgdept.push(data[i].name);
                zgdeptIds.push(data[i].id);
            }
            this.user.zgdept = zgdept.join();
            this.user.zgdeptid = zgdeptIds.join();
        },

        clearZgdept() {
            this.user.zgdept = '';
            this.user.zgdeptid = '';
        },

        cancelChoosePDept() {
            this.mwRef('primaryDeptDialog').hide();
        },

        pDeptSure() {
            let data = this.mwRef('primaryDept').getSelected();
            if (data) {
                this.user.primaryDepartmentName = data.srcName,
                    this.user.primaryDepartmentId = data.id;
                this.cancelChoosePDept();
            } else {
                this.mwMsg('请选择');
            }
        },
        showPtree() {
            if (!this.primaryTree) {
                this.mwRef('primaryDept').refresh();
            }
            this.primaryTree = false;
            this.mwRef('primaryDeptDialog').show();

        },
        toInvalidUser() {
            //因切换后开发环境导航点组织机构没有切换，所以开发环境用户还是原先的路由
            if (!window["$servicePath"]) {
                this.$router.push({ path: '/org/InvalidUser' })
            } else {
                var p = this.$parent;
                do {
                    if (p.changeView) {
                        p.changeView("systemSet_org_InvalidUser");
                    }
                    p = p.$parent;
                } while (p);
            }
        },
        showHelp() {
            // window.open("/helpDoc/organizeApiDoc_2.0/index.html");
            PF.showHelp({ url: '/helpDoc/platform/organization.md' })

        },
        getPYIndexStr() {
            var me = this;
            var name = me.user.name;
            this.mwApi.org.getPYIndexStr(name).then(res => {
                if (res.result) {
                    me.user.pinyin = res.result;
                }
            })
        },
        downloadPersonExcel() {
            var me = this;
            me.mwUtil.downloadAttachment("/template_file/importPersonExcel.xls");
        },
        downloadDeptExcel() {
            var me = this;
            me.mwUtil.downloadAttachment("/template_file/importDepartmentExcel.xls");
        },
        impDeptCancel() {
            this.mwRef('impDeptDialog').hide();
        },
        impUserCancel() {
            this.mwRef('leadDialog').hide();
        },
        cancelHandOverTodo() {
            this.mwRef('handOverTodo').hide();
        },
        chooseHandOverTodoSure() {
            let me = this;
            if (!me.handOverTodoForm.assigned) {
                PF.message($lang("请选择原办理人"));
                return;
            }
            if (!me.handOverTodoForm.recipient) {
                PF.message($lang("请选择交接收人"));
                return;
            }
            PF.invoke("#api/process/handOver", me.handOverTodoForm).then((res) => {
                PF.message($lang("交接成功"));
                me.cancelHandOverTodo();
            })
        },
        cancelHandOverFinish() {
            this.mwRef('handOverFinish').hide();
        },
        chooseHandOverFinishSure() {
            let me = this;
            if (!me.handOverFinishForm.assignedId) {
                PF.message($lang("请选择原办理人"));
                return;
            }
            if (!me.handOverFinishForm.recipientId) {
                PF.message($lang("请选择交接收人"));
                return;
            }
            PF.invoke("#api/data/handOverFinished", me.handOverFinishForm).then((res) => {
                PF.message($lang("交接成功"));
                me.cancelHandOverFinish();
            })
        },
        moduleChoose() {
            let me = this;
            let moduleId = me.handOverFinishForm.moduleId;
            let checkNodes = [];
            if (moduleId) {
                checkNodes = moduleId.split(',');
            }
            PF.show('treeTable', {
                    url: PF.url("/api/app/listApplicationTreeByCategory"),
                    treeDefaultParams: {
                        categories: 'module_flow'
                    },
                    selectFirst: true,
                    clearBtn: true,
                    changed: function(data) {
                        this.defaultParams = {
                            applicationId: data.applicationId,
                            categories: 'module_flow'
                        }
                    },
                    api: 'app.listApplicationItemsByCategory',
                    singleSelect: false
                },
                function(res) {
                    if (res) {
                        var names = [];
                        var ids = [];
                        res.forEach(function(item) {
                            names.push(item.name);
                            ids.push(item.id);
                        });
                        me.handOverFinishForm.moduleId = ids.join(',');
                        me.handOverFinishForm.moduleName = names.join(',');
                    }
                });
        },
        moduleClear() {
            this.handOverFinishForm.moduleId = "";
            this.handOverFinishForm.moduleName = "";
        },
        userChoose(handeOverSelField) {
            this.handeOverSelField = handeOverSelField;
            this.defaultParentId = this.$store.getters.curSelUnitId;
            let userChooseObj = this.mwRef('handOverUserChoose');
            if (userChooseObj) {
                userChooseObj.index = -1; //清空选中状态
                userChooseObj.multipleLSelection = [];
            }
            this.mwRef('userSelDialog').show();
        },
        cancelUserSel() {
            this.mwRef('userSelDialog').hide();
        },
        chooseUserSure() {
            let me = this;
            let data = me.mwRef('handOverUserChoose').getValue();
            if (data.length === 0) {
                PF.message("请选择用户");
                return;
            }
            me.cancelUserSel();
            if (me.handeOverSelField.type == 1) {
                me.handOverTodoForm[me.handeOverSelField.id] = data[0].id
                me.handOverTodoForm[me.handeOverSelField.name] = data[0].name
            } else if (me.handeOverSelField.type == 2) {
                me.handOverFinishForm[me.handeOverSelField.id] = data[0].id
                me.handOverFinishForm[me.handeOverSelField.name] = data[0].name
            }
        },
        queryUserLog() {
            var dataTable = this.mwRef("dataTable").mwRef("dataTable");
            var tableObj = this.mwRef("dataTable");
            tableObj.$on("dataLoaded", function(d) {
                var total = d ? d.length : 0;
                if (tableObj.isSearch) {
                    var rm = "共查询到" + total + "条记录";
                    var params = {
                        flag: "列表查询",
                        targetName: '组织成员',
                        remark: rm,
                        objType: '组织机构',
                        target: '功能',
                        eventType: '三员管理操作',
                        zycd: "一般",
                        result: rm
                    };
                    PF.invoke("sys-log-service.saveOprLog", params);
                }
            })
        },
        clearIp() {
            let me = this;
            me.bindForm.bindIP = "";
        },
        bindUserIp() {
            let me = this;
            let userIds = [];
            let multipleSelection = me.mwRef('dataTable').getMultipleSelection();
            if (multipleSelection.length == 0) {
                me.mwMsg('info', '请选择你需要操作的用户');
            } else if (multipleSelection.length == 1) {
                var r = multipleSelection[0];
                if (r.id) {
                    me.bindForm.userId = r.id;
                } else if (r.ID) {
                    me.bindForm.userId = r.ID;
                }
                if (r.bindIP) {
                    me.bindForm.bindIP = r.bindIP;
                }
                me.mwRef('secDialog').show();
            } else {
                me.mwMsg('info', '请选择一名用户进行绑定操作');
            }
        },
        closeBindIP() {
            this.bindForm.bindIP = "";
            this.mwRef('secDialog').hide();
        },
        saveBindIP() {
            let me = this;
            var bindIPstr = "";
            if (me.bindForm.bindIP && me.bindForm.bindIP != "") bindIPstr = me.bindForm.bindIP.replace(/\s*/g, "");
            if (bindIPstr == "") {
                me.mwMsg('info', '请输入内容');
            } else {
                var selectedTree = me.mwRef('deptTreeData').getSelected();
                var deptid = selectedTree.id;
                me.mwApi.org.updateUserInfo(me.bindForm).then(function(res) {
                    me.refreshTable(deptid, function() {});
                    if (res.success) {
                        me.mwMsg('success', '绑定成功');
                    } else {
                        me.mwMsg('info', '绑定失败');
                    }
                    me.mwRef('secDialog').hide();
                    me.bindForm.bindIP = "";
                });
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/modules/index/views/systemSet/org/organize.js